import {START_TRIGGER_TRACK} from 'constants/action-types.js';
import {STOP_TRIGGER_TRACK} from 'constants/action-types.js';
import {SET_ALL_TRACK_STEPS} from 'constants/action-types.js';
import {CLEAR_DRAG_DROP} from 'constants/action-types.js';
import {SET_TRACK_STEPS} from 'constants/action-types.js';
import {SET_TRACK_UPDATES} from 'constants/action-types.js';
import {SET_TRACK_WARP} from 'constants/action-types.js';
import {SET_SUB_SEQUENCE_WARPS} from 'constants/action-types.js';
import {SET_TRACK_FILLS} from 'constants/action-types.js';
import {SET_TRACK_PIANO_ROLL_STEPS} from 'constants/action-types.js';
import {SET_TRACK_MUTED} from 'constants/action-types.js';
import {SET_TRACK_SOLO} from 'constants/action-types.js';
import {SET_TRACK_VOLUME} from 'constants/action-types.js';
import {SET_TRACK_PANNING} from 'constants/action-types.js';
import {SET_GROUP_MUTED} from 'constants/action-types.js';
import {SET_GROUP_PANNING} from 'constants/action-types.js';
import {SET_GROUP_VOLUME} from 'constants/action-types.js';
import {SET_SEND_MUTED} from 'constants/action-types.js';
import {SET_TRACK_SEND_VOLUME} from 'constants/action-types.js';
import {SET_TRACK_IS_ENABLED} from 'constants/action-types.js';
import {SET_SELECTED_SAMPLE_TAG} from 'constants/action-types.js';
import {SET_TRACKS_TO_RESAMPLE} from 'constants/action-types.js';
import {SET_IS_RESAMPLING} from 'constants/action-types.js';
import {SET_TRACK_PATTERN_LOCKED} from 'constants/action-types.js';
import {SET_TRACK_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_ENVELOPE_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_LFO_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_RESAMPLE_DURATION} from 'constants/action-types.js';
import {SET_TRACK_EFFECTS_CHAIN} from 'constants/action-types.js';
import {SET_SHOW_TRACK_EFFECTS} from 'constants/action-types.js';
import {HIDE_ALL_EFFECTS} from 'constants/action-types.js';
import {UPDATE_STEPS_FOR_ALL_TRACKS} from 'constants/action-types.js';
import {NEW_SEQUENCE} from 'constants/action-types.js';
import {SET_ALL_TRACK_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_ALL_ENVELOPE_LOCKS} from 'constants/action-types.js';
import {SET_ALL_LFO_LOCKS} from 'constants/action-types.js';
import {SET_SAMPLE_SLICES} from 'constants/action-types.js';
import {SET_TRACK_FROZEN} from 'constants/action-types.js';
import {SET_TRACK_TO_FREEZE} from 'constants/action-types.js';
import {SET_FROZEN_TRACK_PLAYING} from 'constants/action-types.js';
import {SET_FROZEN_TRACKS} from 'constants/action-types.js';
import {SET_FROZEN_TRACKS_PLAYING} from 'constants/action-types.js';
import {SET_PARAMETERS_TO_RECORD} from 'constants/action-types.js';
import {SET_TRACK_IS_LOADING} from 'constants/action-types.js';
import {SET_ANNOTATION_DRAGGING} from 'constants/action-types.js';
import {SET_SELECTED_RACK_SUB_TRACK} from 'constants/action-types.js';
import {SET_TRACK_TO_CONVERT} from 'constants/action-types.js';
import {SET_TRACK_BROWSED_SAMPLES} from 'constants/action-types.js';
import {SET_TRACK_BROWSED_PRESETS} from 'constants/action-types.js';
import {SET_TRACK_LENGTH_MODE} from 'constants/action-types.js';
import {SET_TRACK_LENGTH_CHOICE} from 'constants/action-types.js';
import {SET_GROUP_TRACKS} from 'constants/action-types.js';
import {SET_TRACK_ENVELOPES} from 'constants/action-types.js';
import {SET_TRACKS_TO_HIDE} from 'constants/action-types.js';
import {SET_SELECTED_MIDI_TRACK} from 'constants/action-types.js';
import {SET_SELECTED_TRACK_SLICE} from 'constants/action-types.js';
import {SET_TRACK_DRAGGING} from 'constants/action-types.js';
import {SET_SHOW_TRACK_FREEZE_HISTORY} from 'constants/action-types.js';
import {DELETE_TRACK_ID} from 'constants/action-types.js';

let initialState = {
    selectedTrackSlice: {},
    tracksToHide: [],
    selectedMidiTrack: 0,
    triggers: {},
    trackSteps: {},
    trackToConvert: undefined,
    trackLengthMode: false,
    trackStepGroups: {},
    trackLengthChoice: 0,
    trackStepIds: {},
    selectedRackSubTrack: {},
    trackFills: {},
    tracksFrozen: {},
    frozenTracksPlaying: {},
    trackPatternSteps: {},
    trackPianoRollSteps: {},
    trackPianoRollDurations: {},
    trackVolumes: {},
    trackPannings: {},
    trackMutes: {},
    trackSolos: {},
    groupVolumes: {},
    groupPannings: {},
    trackEnvelopes: {},
    groupMutes: {},
    trackWarps: {},
    trackPianoRollPositions: {},
    sendMutes:{},
    trackSendVolumes:{},
    trackIsEnabled: {},
    selectedSampleTags: {},
    tracksToResample: [],
    trackToFreeze: undefined,
    trackPatternLocks: {},
    trackEffectsChain: {},
    showTrackEffects: {},
    showTrackFreezeHistory: {},
    lfoPatternLocks: {},
    envelopePatternLocks: {},
    isResampling: false,
    resampleDuration: 1,
    sampleSlices: {},
    trackIsLoading: {},
    annotationDragging: undefined,
    allSteps: {},
    trackBrowsedSamples: {},
    trackBrowsedPresets: {},
    groupTracks: {},
    trackEnvelopes: {},
};
    
const tracksReducer= (state = initialState, action) => {
    let newState;
    let track = undefined;
    let subSequence = undefined; 
    switch (action.type) {
    case NEW_SEQUENCE:
        return initialState;
    case DELETE_TRACK_ID:
        newState = {... state};
        let _id = action.payload;
        delete newState.trackSteps[_id];
        delete newState.trackFills[_id]
        delete newState.trackStepIds[_id];
        delete newState.trackPatternSteps[_id];
        delete newState.trackPianoRollSteps[_id];
        delete newState.trackPianoRollPositions[_id];
        delete newState.trackPianoRollDurations[_id];
        delete newState.trackMutes[_id];
        return newState;
    case CLEAR_DRAG_DROP:
        return {
            ... state,
            trackDragging: undefined
        };
    case SET_TRACK_DRAGGING:
        console.log("SET TRACK DRAGGING", action.payload);
        return {
            ... state,
            trackDragging: action.payload
        };
    case START_TRIGGER_TRACK:
        newState = {... state};
        if (newState.triggers[action.payload.trackNumber] === undefined) {
            newState.triggers[action.payload.trackNumber] = {};
        }
        newState.triggers[action.payload.trackNumber][action.payload.sliceNumber] = true;
        return newState;
    case STOP_TRIGGER_TRACK:
        newState = {... state};
        if (newState.triggers[action.payload.trackNumber] === undefined) {
            newState.triggers[action.payload.trackNumber] = {};
        }
        newState.triggers[action.payload.trackNumber][action.payload.sliceNumber] = false;
        return newState;
    case SET_ALL_TRACK_STEPS:
        newState = {... state};
        newState.trackSteps[action.payload.id] = action.payload.steps;
        newState.trackPatternSteps[action.payload.id] = action.payload.patternSteps;
        newState.trackFills[action.payload.id] = action.payload.fills;
        newState.trackStepIds[action.payload.id] = action.payload.stepToId;
        newState.trackStepGroups[action.payload.id] = action.payload.groups;
        if (action.payload.pianoRollSteps) {
            newState.trackPianoRollSteps[action.payload.id] = action.payload.pianoRollSteps;
        }
        newState.trackPianoRollPositions[action.payload.id] = action.payload.stepToPosition;
        newState.trackPianoRollDurations[action.payload.id] = action.payload.pianoRollDurations;
        return {
            ... newState,
            ... combineAllSteps(newState)
        };
    case UPDATE_STEPS_FOR_ALL_TRACKS:
        newState = {... state};
        /*
        newState.trackSteps = {};
        newState.trackFills = {};
        newState.trackPianoRollSteps = {};
        newState.trackStepIds = {};
        newState.trackPatternSteps = {};
        newState.trackPianoRollPositions  = {};
        newState.trackPianoRollDurations  = {};
        newState.trackMutes = {};
        */
        for (let i in action.payload) {
            let updateData = action.payload[i];
            newState.trackSteps[updateData.id] = updateData.steps;
            newState.trackFills[updateData.id] = updateData.trackFills;
            newState.trackStepIds[updateData.id] = updateData.stepToId;
            newState.trackPatternSteps[updateData.id] = updateData.trackPatternSteps;
            if (updateData.pianoRollSteps !== undefined) {
                newState.trackPianoRollSteps[updateData.id] = updateData.pianoRollSteps;
            }
            newState.trackPianoRollPositions[updateData.id] = updateData.pianoRollPositions;
            newState.trackPianoRollDurations[updateData.id] = updateData.pianoRollDurations;
            newState.trackMutes[updateData.id] = updateData.muted;
        }
        return {
            ...newState,
            ... combineAllSteps(newState)
        };
    case SET_TRACK_STEPS:
        newState = {... state};
        newState.trackSteps[action.payload.id] = action.payload.steps;
        return newState;
    case SET_TRACK_FILLS:
        newState = {... state};
        newState.trackFills[action.payload.id] = action.payload.fills;
        return newState;
    case SET_SELECTED_MIDI_TRACK:
        return {
            ... state,
            selectedMidiTrack: action.payload
        };
    case SET_TRACK_PIANO_ROLL_STEPS:
        newState = {... state};
        newState.trackPianoRollSteps[action.payload.id] = action.payload.steps;
        return {
            ... newState,
            ... combineAllSteps(newState)
        };
    case SET_TRACK_MUTED:
        newState = {... state};
        newState.trackMutes[action.payload.id] = action.payload.muted;
        return newState;
    case SET_TRACK_SOLO:
        newState = {... state};
        newState.trackSolos[action.payload.id] = action.payload.solo;
        return newState;
    case SET_SELECTED_TRACK_SLICE:
        newState = {... state};
        newState.selectedTrackSlice[action.payload.track] = action.payload.slice;
        return newState;
    case SET_TRACK_VOLUME:
        newState = {... state};
        newState.trackVolumes[action.payload.id] = action.payload.volume;
        return newState;
    case SET_TRACK_PANNING:
        newState = {... state};
        newState.trackPannings[action.payload.id] = action.payload.pan;
        return newState;
    case SET_TRACK_UPDATES:
        newState = {... state};
        for (let trackNumber in action.payload) {
            newState.trackPannings[trackNumber] = action.payload[trackNumber].panning;
            newState.trackVolumes[trackNumber] = action.payload[trackNumber].volume;
            newState.trackMutes[trackNumber] = action.payload[trackNumber].mute;
        }
        return newState;
    case SET_GROUP_VOLUME:
        newState = {... state};
        newState.groupVolumes[action.payload.groupNumber] = action.payload.volume;
        return newState;
    case SET_GROUP_PANNING:
        newState = {... state};
        newState.groupPannings[action.payload.groupNumber] = action.payload.pan;
        return newState;
    case SET_GROUP_MUTED:
        newState = {... state};
        newState.groupMutes[action.payload.groupNumber] = action.payload.muted;
        return newState;
    case SET_SEND_MUTED:
        newState = {... state};
        newState.sendMutes[action.payload.sendNumber] = action.payload.muted;
        return newState;
    case SET_TRACK_SEND_VOLUME:
        newState = {... state};
        track = newState.trackSendVolumes[action.payload.trackVolume];
        if (track === undefined) {
            track = {};
        }
        track[action.payload.sendNumber] = action.payload.volume;
        newState.trackSendVolumes[action.payload.trackVolume] = track;
        return newState;
    case SET_TRACK_IS_ENABLED:
        newState = {... state};
        let isEnabled = newState.trackIsEnabled[action.payload.subSequenceId] || {};
        isEnabled[action.payload.trackNumber] = action.payload.isEnabled;
        newState.trackIsEnabled[action.payload.subSequenceId] = isEnabled;
        return newState;
    case SET_TRACK_WARP:
        newState = {... state};
        let warps = newState.trackWarps[action.payload.subSequenceId] || {};
        warps[action.payload.trackNumber] = action.payload.warp;
        newState.trackWarps[action.payload.subSequenceId] = warps;
        return newState;
    case SET_SUB_SEQUENCE_WARPS:
        newState = {... state};
        newState.trackWarps[action.payload.subSequenceId] = action.payload.warps;
        return newState;
    case SET_SELECTED_SAMPLE_TAG:
        newState = {... state};
        newState.selectedSampleTags[action.payload.sampleId] = action.payload.tag;
        return newState;
    case SET_ALL_TRACK_PATTERN_LOCKS:
        return {
            ... state,
            trackPatternLocks: action.payload
        };
    case SET_ALL_LFO_LOCKS:
        return {
            ... state,
            lfoPatternLocks: action.payload
        };
     case SET_ALL_ENVELOPE_LOCKS:
        return {
            ... state,
            envelopePatternLocks: action.payload
        };
     case SET_TRACK_TO_FREEZE:
        return {
            ... state,
            trackToFreeze: action.payload
        };
    case SET_TRACK_PATTERN_LOCKED:
        newState = {... state};
        if (newState.trackPatternLocks[action.payload.subSequence] === undefined) {
            newState.trackPatternLocks[action.payload.subSequence] = {};
        }
        track = newState.trackPatternLocks[action.payload.subSequence][action.payload.trackNumber] || {};
        track[action.payload.patternNumber] = action.payload.locked;
        newState.trackPatternLocks[action.payload.subSequence][action.payload.trackNumber] = track;
        return newState;
    case SET_TRACK_PATTERN_LOCKS:
        newState = {... state};
        if (newState.trackPatternLocks[action.payload.subSequence] === undefined) {
            newState.trackPatternLocks[action.payload.subSequence] = {};
        }
        newState.trackPatternLocks[action.payload.subSequence][action.payload.trackNumber] =
            action.payload.patternLocks;
        return newState;
    case SET_TRACKS_TO_RESAMPLE:
        return {... state,
                tracksToResample: action.payload};
    case SET_ENVELOPE_PATTERN_LOCKS:
        newState = {... state};
        newState.envelopePatternLocks[action.payload.subSequence] =
            action.payload.patternLocks;
        return newState;
    case SET_LFO_PATTERN_LOCKS:
        newState = {... state};
        newState.lfoPatternLocks[action.payload.subSequence] =
            action.payload.patternLocks;
        return newState;
    case SET_IS_RESAMPLING:
        return {... state,
                isResampling: action.payload};
    case SET_RESAMPLE_DURATION:
        return {
            ... state,
            resampleDuration: action.payload};
    case SET_TRACK_EFFECTS_CHAIN:
        newState = {... state};
        newState.trackEffectsChain[action.payload.trackNumber] =
            action.payload.effectsChain;
        return newState;
     case SET_SAMPLE_SLICES:
        newState = {... state};
        newState.sampleSlices[action.payload.id] = action.payload.slices;
        return newState;
    case SET_SHOW_TRACK_EFFECTS:
        newState = {... state};
        newState.showTrackEffects[action.payload.trackNumber] =
            action.payload.show;
        return newState;
    case SET_SHOW_TRACK_FREEZE_HISTORY:
        newState = {... state};
        newState.showTrackFreezeHistory[action.payload.id] =
            action.payload.show;
        return newState;
    case HIDE_ALL_EFFECTS:
        newState = {... state};
        for (let i in newState.showTrackEffects) {
            newState.showTrackEffects[i] = false;
        }
        return newState;
    case SET_TRACK_FROZEN:
        newState = {... state};
        subSequence = newState.tracksFrozen[action.payload.subSequenceId] || {};
        subSequence[action.payload.trackNumber] = action.payload.frozen;
        newState.tracksFrozen[action.payload.subSequenceId] = subSequence;
        return newState;
    case SET_TRACK_IS_LOADING:
        newState = {... state};
        subSequence = newState.trackIsLoading[action.payload.subSequenceId] || {};
        subSequence[action.payload.trackNumber] = action.payload.isLoading;
        newState.trackIsLoading[action.payload.subSequenceId] = subSequence;
        return newState;
    case SET_FROZEN_TRACK_PLAYING:
        newState = {... state};
        subSequence = newState.frozenTracksPlaying[action.payload.subSequenceId] || {};
        subSequence[action.payload.trackNumber] = action.payload.playing;
        newState.frozenTracksPlaying[action.payload.subSequenceId] = subSequence;
        return newState;
    case SET_FROZEN_TRACKS:
        newState = {... state};
        newState.tracksFrozen[action.payload.subSequenceId] =
            action.payload.frozenTracks;
        return newState;
    case SET_FROZEN_TRACKS_PLAYING:
        newState = {... state};
        newState.frozenTracksPlaying[action.payload.subSequenceId] =
            action.payload.frozenTracksPlaying;
        return newState;
    case SET_PARAMETERS_TO_RECORD:
        newState = {... state};
        newState.parametersToRecord = action.payload;
        return newState;
    case SET_ANNOTATION_DRAGGING:
        return {
            ... state,
            annotationDragging: action.payload
        };
    case SET_TRACK_BROWSED_SAMPLES:
        let trackBrowsedSamples = {... state.trackBrowsedSamples};
        trackBrowsedSamples[action.payload.trackId] = action.payload.samples;
        return {
            ... state,
            trackBrowsedSamples
        };
    case SET_TRACK_BROWSED_PRESETS:
        let trackBrowsedPresets = {... state.trackBrowsedPresets};
        trackBrowsedPresets[action.payload.trackId] = action.payload.presets;
        return {
            ... state,
            trackBrowsedPresets
        };
    case SET_TRACK_TO_CONVERT:
        return {
            ... state,
            trackToConvert: action.payload
        };

    case SET_TRACKS_TO_HIDE:
        return {
            ... state,
            tracksToHide: action.payload
        };
    case SET_SELECTED_RACK_SUB_TRACK:
        let selectedRackSubTrack = {... state.selectedRackSubTrack};
        selectedRackSubTrack[action.payload.trackId] = action.payload.track;
        return {
            ... state,
            selectedRackSubTrack
        };
    case SET_TRACK_LENGTH_MODE:
        return {
            ... state,
            trackLengthMode: action.payload
        };
    case SET_TRACK_LENGTH_CHOICE:
        return {
            ... state,
            trackLengthChoice: action.payload
        };
    case SET_GROUP_TRACKS:
        let groupTracks = state.groupTracks;
        groupTracks[action.payload.groupId] = action.payload.tracks;
        return {
            ... state,
            groupTracks
        };
    case SET_TRACK_ENVELOPES:
        let trackEnvelopes = {... state.trackEnvelopes};
        trackEnvelopes[action.payload.id] = action.payload.envelopes;
        return {
            ... state,
            trackEnvelopes
        };
    default:
        return state;
    }
};

const combineAllSteps = (state) => {
    let newSteps = {};
    let newDurations = {};
    let newPositions  = {};

    let tracksSteps = state.trackPianoRollSteps;
    let trackDurations = state.trackPianoRollDurations;
    let trackPositions = state.trackPianoRollPositions;

    for (let track in tracksSteps) {
        let notes = tracksSteps[track];
        for (let note in notes) {
            let steps = notes[note];
            let durations = trackDurations[track][note];
            let positions = trackPositions[track][note];

            if (newSteps[note] === undefined) {
                newSteps[note] = {};
                newDurations[note] = {};
                newPositions[note] = {};
            }
            for (let stepNumber in steps) {
                if (steps[stepNumber]) {
                    newSteps[note][stepNumber] = parseInt(track);
                }
                newPositions[note][stepNumber] = positions[stepNumber];
                newDurations[note][stepNumber] = durations[stepNumber];
            }
        }
    }
    return {
        allSteps: newSteps,
        allPositions: newPositions,
        allDurations: newDurations 
    };
};

export default tracksReducer;
